import { HttpClient, Logger } from '@openticket/lib-shop';

const TURNSTILE_SCRIPT_URL =
    'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

let turnstileToken: string | null = null;

export function setTurnstileToken(token: string | null): void {
    turnstileToken = token;
}

export function getTurnstileToken(): string | null {
    return turnstileToken;
}

export function registerTurnstile(
    log: Logger,
    shopApiUrl: string,
    http?: HttpClient | undefined
): boolean {
    if (!http) {
        return false;
    }

    http.interceptors.request.use(request => {
        const apiHost = new URL(shopApiUrl).hostname;
        const interceptedHost = new URL(request.url || '').hostname;

        if (apiHost && interceptedHost === apiHost && turnstileToken) {
            request.headers.set('x-turnstile-cf-response', turnstileToken);
        }

        return request;
    });

    return true;
}

export function isTurnstileAvailable(): boolean {
    return !!(
        window.turnstile &&
        typeof window.turnstile === 'object' &&
        typeof window.turnstile.render === 'function'
    );
}

export function loadTurnstileScript(): Promise<void> {
    return new Promise((resolve, reject) => {
        if (isTurnstileAvailable()) {
            resolve();
            return;
        }

        const existing = document.querySelector(
            `script[src^="https://challenges.cloudflare.com/turnstile"]`
        );
        if (existing) {
            existing.addEventListener('load', () => resolve());
            existing.addEventListener('error', () =>
                reject(new Error('Failed to load Turnstile script'))
            );
            return;
        }

        const script = document.createElement('script');
        script.src = TURNSTILE_SCRIPT_URL;
        script.async = true;
        script.addEventListener('load', () => resolve());
        script.addEventListener('error', () =>
            reject(new Error('Failed to load Turnstile script'))
        );
        document.head.appendChild(script);
    });
}
